<template>
<div class="result">
  <h2>Отлично! Молодец! Повторим?</h2>

  <div class="result__list">
    <span>Времени потрачено: {{ time }} </span>
    <span>Ошибки: {{ result.errors }}</span>
    <span class="scores">Балов заработано: <strong>{{ scores }}</strong></span>
  </div>

  <div class="result__buttons">
    <button 
      class="uk-button uk-button-primary" 
      @click="$emit('again', result.gameParams)" 
    >
      Повторить!
    </button>
    <a href="#" @click.prevent="stop">Остановить</a>
  </div>

  <div class="wh-block wh-block--reaction" v-if="reaction">
		<div class="reaction">
			<video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
				<source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
			</video>
		</div>
	</div>
 
</div>
</template>

<script>
import { homework_stat_mix } from '../../homework_stat_mix'
import { reactions_mix } from '../../reactions_mix'
export default {
  mixins: [ homework_stat_mix, reactions_mix ],
  props: ['result'],
  data() {
    return {
      coefficient: {
        8: 2.6, 10: 2.2, 12: 2, 14: 1.9, 16: 1.8 
      }
    }
  },
  computed: {
    time() {
      let minutes = this.result.elapsedTime.minutes
      let seconds = this.result.elapsedTime.seconds

      return minutes + ' мин. ' + seconds + ' сек.'
    },
    scores() {
      let sum = 0;
      if (this.result.errors < 10) {
        let scores = (this.result.gameParams.size * this.result.gameParams.size) * (1 - (this.result.errors / 10));

        sum = Math.ceil(scores);

        if(this.$route.params.isHomework){
          sum = Math.ceil(sum * this.$store.state.hw_coefficient);
        }
        this.checkScoreStatus(sum);
      }

      return sum
    },
    stat() {
      return {
        time: this.result.elapsedTime,
        errors: this.result.errors,
        user_id: this.result.user_id,
        trainer: this.result.trainer,
        scores: this.scores,
        train_params: this.result.gameParams
      }
    }
  },
  methods: {
    stop() {
      this.$emit('stop')
      if (this.$route.params.isHomework) {
        this.$router.go(-1)
      }
    },
  },
  mounted() {
    this.saveStat(this.stat)

    if (this.result.gameParams.reactions) {
      this.startReaction();
    }    
  }
}
</script>

<style lang="scss" scoped>
.result__list {
  display: flex;
  flex-direction: column;

  & span {
    margin-bottom: 10px;
  }
}
.result__buttons {
  margin-top: 40px;
}
</style>
